import { Injectable } from "@angular/core";
import { LocalStorageService } from "./local-storage.service";
import {
  IRequestPwdRecovery,
  IResetPassword,
  IUserCredentials,
} from "../data-types/user.interface";
import { HttpClientService } from "./http-client.service";
import { EStorageType } from "../data-types/storage.enum";
import { IService } from "../data-types/services.interface";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class BackofficeService {
  static instance: BackofficeService = new BackofficeService();
  constructor() {
    return (BackofficeService.instance = BackofficeService.instance || this);
  }
  public companyModified = new Subject();
  public spaceModified = new Subject();
  public async getCompanies(params): Promise<any> {
    const queryparams = Object.keys(params)
      .filter((key) => params[key] !== null)
      .map((key) => key + "=" + params[key])
      .join("&");
    return new Promise((resolve, reject) => {
      let url: string = "cms/companies?" + queryparams;
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };
      let body = params;
      HttpClientService.instance
        .get(url, headers)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async getCoworkers(params): Promise<any> {
    const queryparams = Object.keys(params)
      .filter((key) => params[key] !== null)
      .map((key) => key + "=" + params[key])
      .join("&");
    return new Promise((resolve, reject) => {
      let url: string = "cms/coworkers?" + queryparams;
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };
      let body = params;
      HttpClientService.instance
        .get(url, headers)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async deleteCompany(id): Promise<any> {
    return new Promise((resolve, reject) => {
      let url: string = "cms/companies/" + id;
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };
      HttpClientService.instance
        .delete(url, headers)
        .then((result: any) => {
          this.companyModified.next();
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async getCompany(id) {
    return new Promise((resolve, reject) => {
      let url: string = `cms/companies/${id}`;
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };
      HttpClientService.instance
        .get(url, headers)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async editCompany(id, body) {
    return new Promise((resolve, reject) => {
      let url: string = `cms/companies/${id}`;
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };

      HttpClientService.instance
        .patch(url, headers, body)
        .then((result: any) => {
          resolve(result);
          this.companyModified.next();
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async getCoworkings(params?): Promise<any> {
    let queryparams;
    if (params) {
      queryparams = Object.keys(params)
        .filter((key) => params[key] !== null)
        .map((key) => key + "=" + params[key])
        .join("&");
    }

    return new Promise((resolve, reject) => {
      let url: string = "cms/coworkings?" + queryparams;
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };
      let body = params;
      HttpClientService.instance
        .get(url, headers)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public async getSpaces(params?): Promise<any> {
    let queryparams;
    if (params) {
      queryparams = Object.keys(params)
        .filter((key) => params[key] !== null)
        .map((key) => key + "=" + params[key])
        .join("&");
    }

    return new Promise((resolve, reject) => {
      let url: string = "cms/spaces?" + queryparams;
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };
      let body = params;
      HttpClientService.instance
        .get(url, headers)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async changeCompanyStatus(companyId, newStatus) {
    return new Promise((resolve, reject) => {
      let url: string = "cms/companies/" + companyId + "/status/" + newStatus;
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };
      let body = {};
      HttpClientService.instance
        .patch(url, headers, body)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async changeBookingStatus(companyId, newStatus) {
    return new Promise((resolve, reject) => {
      let url: string = "cms/bookings/" + companyId + "/status/" + newStatus;
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };
      let body = {};
      HttpClientService.instance
        .patch(url, headers, body)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public async changeCoworkingStatus(coworkingId, newStatus) {
    return new Promise((resolve, reject) => {
      let url: string =
        "cms/coworkings/" + coworkingId + "/status/" + newStatus;
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };
      let body = {};
      HttpClientService.instance
        .patch(url, headers, body)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async getUsers(params?): Promise<any> {
    let queryparams;
    if (params) {
      queryparams = Object.keys(params)
        .filter((key) => params[key] !== null)
        .map((key) => key + "=" + params[key])
        .join("&");
    }

    return new Promise((resolve, reject) => {
      let url: string = "cms/users?" + queryparams;
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };
      let body = params;
      HttpClientService.instance
        .get(url, headers)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async getBookings(params?): Promise<any> {
    let queryparams;
    if (params) {
      queryparams = Object.keys(params)
        .filter((key) => params[key] !== null)
        .map((key) => key + "=" + params[key])
        .join("&");
    }

    return new Promise((resolve, reject) => {
      let url: string = "cms/bookings?" + queryparams;
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };
      let body = params;
      HttpClientService.instance
        .get(url, headers)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async getAllSpacesRaw(): Promise<any> {
    return new Promise((resolve, reject) => {
      let url: string = "cms/spaces/list";
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };
      // let body = params;
      HttpClientService.instance
        .get(url, headers)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async getSpace(id) {
    return new Promise((resolve, reject) => {
      let url: string = "cms/spaces/" + id;
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };
      // let body = params;
      HttpClientService.instance
        .get(url, headers)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public async patchSpacePrices(id, params) {
    return new Promise((resolve, reject) => {
      let url: string = "cms/spaces/" + id + "/prices";
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };
      let body = params;
      HttpClientService.instance
        .patch(url, headers, body)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async patchSpace(id, params) {
    return new Promise((resolve, reject) => {
      let url: string = "cms/spaces/" + id;
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };
      let body = params;
      HttpClientService.instance
        .patch(url, headers, body)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
